import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Icon } from 'react-icons-kit';
import { useStaticQuery, graphql } from 'gatsby';
import { androidStar } from 'react-icons-kit/ionicons/androidStar';

import Container from 'common/components/UI/Container';
import Heading from 'common/components/Heading';
import Image from 'common/components/Image';
import Text from 'common/components/Text';
import 'swiper/css/bundle';
import {
  Section,
  SectionHeading,
  ContentWrapper,
  Item,
} from './testimonials.style';

const options = {
  slidesPerView: 1,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    // when window width is >= 768px
    768: {
      slidesPerView: 2,
    },
  },
};

const ratingCount = (rating) => {
  let ratings = [];
  for (let i = 1; i <= rating; i++) {
    ratings.push(<Icon key={i} icon={androidStar} />);
  }
  return ratings;
};

const Testimonial = () => {
  const data = useStaticQuery(graphql`
    query {
      saasMinimal2Json {
        testimonials {
          id
          name
          designation
          text
          rating
          photo {
            publicURL
          }
        }
      }
    }
  `);
  return (
    <Section id="testimonials">
      
        <SectionHeading>
          <Heading content="Applicat oferă brandurilor și influencerilor cele mai bune rețete pentru campaniile de promovare. 
Inteligența Artificială identifică tipare, comportamente de utilizator și oportunități de engagement." />
        </SectionHeading>
      
    </Section>
  );
};

export default Testimonial;
